import { useEffect, useRef, useState } from "react";
import Collection from "./categories/collection";
import { useLocation } from 'react-router-dom';

export default function AnimalInfo(props){
  
		const [scrollY, setScrollY] = useState(0);
    const [data, setData] = useState([]);
	  
		const handleScroll = () => {
		  setScrollY(window.scrollY);
		};
	  
		useEffect(() => {

      switch (props.title) {

        case 'Amphibians':
            fetch('https://biouniverse-api.vercel.app/category_amphibian')
              .then(res => res.json())
              .then(data => {
                setData(data)})
              .catch(err => console.log(err));
          break;

        case 'Birds':
            fetch('https://biouniverse-api.vercel.app/category_birds')
              .then(res => res.json())
              .then(data => {
                setData(data)})
              .catch(err => console.log(err));
          break;

        case 'Mammals':
            fetch('https://biouniverse-api.vercel.app/category_mammals')
              .then(res => res.json())
              .then(data => {
                setData(data)})
              .catch(err => console.log(err));
          break;

        case 'Marines':
            fetch('https://biouniverse-api.vercel.app/category_marines')
              .then(res => res.json())
              .then(data => {
                setData(data)})
              .catch(err => console.log(err));
          break;

        case 'Reptiles':
            fetch('https://biouniverse-api.vercel.app/category_reptiles')
              .then(res => res.json())
              .then(data => {
                setData(data)})
              .catch(err => console.log(err));
          break;

        case 'Endangered':
            fetch('https://biouniverse-api.vercel.app/category_endangered')
              .then(res => res.json())
              .then(data => {
                setData(data)})
              .catch(err => console.log(err));
          break;
        
        default:
          console.log('incorrect url somehow!');
          break;
      }

		  window.addEventListener('scroll', handleScroll);
		  return () => {
			window.removeEventListener('scroll', handleScroll);
		  };
		}, []);
	  
		const parallaxStyle = {
		  transform: `translateY(${scrollY * .2}px)`
		};


      const location = useLocation();
      const prevLocationRef = useRef(location.pathname);
    
      useEffect(() => {
        // Check if the URL has changed since the last reload
        if (prevLocationRef.current !== location.pathname) {
          // If the URL has changed, trigger the page reload
          window.location.reload();
        }
    
        // Update the previous URL to the current URL
        prevLocationRef.current = location.pathname;
      }, [location.pathname]);
    
    return(
        <>
		<div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		</div>
	

        <div className="country_jungle_wrapper">
		<div className="country_jungle_content">

		<header className="country_jungle_main-header">
      <div className="country_jungle_layers">
        <div className="country_jungle_layer__header" style={parallaxStyle}>
          <div className="country_jungle_layers__caption">{props.slogan}</div>
          <div className="country_jungle_layers__title">{props.title}</div>
        </div>
        <div
          className="country_jungle_layer country_jungle_layers__base"
          style={{
            backgroundImage: "url(assets/CountryScroll/img/layer-base.webp)",
            transform: `translateY(${scrollY * .1}px)` 
          }}
        ></div>
        <div
          className="country_jungle_layer country_jungle_layers__middle"
          style={{
            backgroundImage: "url(assets/CountryScroll/img/layer-middle.webp)",
            transform: `translateY(${scrollY * .1}px)`
          }}
        ></div>
        <div
          className="country_jungle_layer country_jungle_layers__front"
          style={{
            backgroundImage: "url(assets/CountryScroll/img/layer-front.webp)",
            transform: `translateY(${scrollY * -0.02}px)`
          }}
        ></div>
      </div>
    </header>
		
			{/* #0B1316 */}


			<article className="country_jungle_main-article" style={{background: '#060504', backgroundSize: 'cover'}}> 
				<div className="country_jungle_main-article__content">
				
				<div style={{display: 'block', marginBottom: '10rem', marginTop: "5rem" }}>
                    <Collection data= {data}/>
        </div>
				</div>
				<div className="country_jungle_copy" style={{fontSize: '1rem', marginTop: '4rem'}}>
      <hr style={{border: 'solid 2px white', width: '100vw', marginBottom: '2rem'}}></hr>
          © BioUniverse -Vishal
        </div>
			</article>
		</div>
	</div>
        </>
    );
}